// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, enableNetwork, disableNetwork } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC4C1WD_OPuO6Op2SiZhtUlKpdV95Z1ulQ",
  authDomain: "florentina-731af.firebaseapp.com",
  projectId: "florentina-731af",
  storageBucket: "florentina-731af.appspot.com",
  messagingSenderId: "952952450203",
  appId: "1:952952450203:web:c7f709c5792d31b5c7ea3e",
  measurementId: "G-G6ERVF2TF9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(app);

// Get the database ID from environment variables
// If not specified or set to 'default', use the default database (don't specify databaseId)
const databaseId = process.env.REACT_APP_FIREBASE_DATABASE_ID;

// Initialize Firestore with the appropriate database
// If databaseId is undefined or 'default', use the true default database
const db = (!databaseId || databaseId === 'default')
  ? getFirestore(app)
  : getFirestore(app, databaseId);

// Force network enable on initialization to avoid offline state
enableNetwork(db).then(() => {
  console.log('[Firebase] Network enabled successfully');
}).catch((error) => {
  console.warn('[Firebase] Could not enable network:', error);
});

// Monitor online/offline status
window.addEventListener('online', () => {
  console.log('[Firebase] Back online, enabling network');
  enableNetwork(db).catch((error) => {
    console.error('[Firebase] Failed to enable network:', error);
  });
});

window.addEventListener('offline', () => {
  console.log('[Firebase] Gone offline, disabling network');
  disableNetwork(db).catch((error) => {
    console.error('[Firebase] Failed to disable network:', error);
  });
});

console.log(`[Firebase] Using database: ${databaseId || 'default (unnamed)'}`);

export { db, auth, enableNetwork, disableNetwork };
